import { MolsonButton } from '../molson-button'
import {
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogHeader
} from '../molson-dialog'
import type { IconColor, IconVariant } from '../molson-icons'

export type MolsonLeaveGuardProps = {
  closeLeaveConfirmationDialog: () => void
  handleConfirm: () => void
  isLeaveConfirmationOpen: boolean
  title: string
  subtitle?: string
  cancelBtnText?: string
  confirmBtnText?: string
  titleIconType?: IconVariant | null
  iconColor?: IconColor
  onClose?: () => void
  isConfirmBtnDisabled?: boolean
  isCancelBtnDisabled?: boolean
}

export const MolsonLeaveGuard = ({
  closeLeaveConfirmationDialog,
  handleConfirm,
  isLeaveConfirmationOpen,
  title,
  subtitle,
  cancelBtnText = 'Cancel',
  confirmBtnText = 'Confirm',
  titleIconType = 'WARNING',
  iconColor = 'warning',
  onClose,
  isCancelBtnDisabled = false,
  isConfirmBtnDisabled = false
}: MolsonLeaveGuardProps) => {
  return (
    <MolsonDialog
      fullWidth={true}
      maxWidth="sm"
      open={isLeaveConfirmationOpen}
      onClose={onClose}
    >
      <MolsonDialogHeader
        handleCloseDialog={onClose}
        hasCloseIcon={true}
        title={title}
        subTitle={subtitle}
        headerIcon={titleIconType}
        iconColor={iconColor}
        displayDivider={false}
      />
      <MolsonDialogActions displayDivider={false}>
        <MolsonButton
          onClick={closeLeaveConfirmationDialog}
          color="secondary"
          variant="outlined"
          disabled={isCancelBtnDisabled}
        >
          {cancelBtnText}
        </MolsonButton>
        <MolsonButton
          onClick={handleConfirm}
          variant="contained"
          disabled={isConfirmBtnDisabled}
        >
          {confirmBtnText}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
